import { Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowDown } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React, { useMemo } from 'react';

import { pluralizeCredits, pluralizeCards } from 'shared/lib/pluralize';
import type { TVitrinsOffersCardProps } from 'shared/ui/VitrinsOffersCard';

import styles from './ShowMoreOffers.module.scss';

type Props = {
  isShowMore: boolean;
  offersType: TVitrinsOffersCardProps['type'];
  countOffers: number;
  onClick?: () => void;
};

export const ShowMoreOffers: FC<Props> = (props) => {
  const { isShowMore, offersType, countOffers, onClick } = props;
  const isMobile = useIsMobile();

  const offersCountText = useMemo(() => {
    switch (offersType) {
      case 'credit':
        return `Еще ${countOffers} ${pluralizeCredits(countOffers)}`;
      case 'creditCard':
        return `Еще ${countOffers} ${pluralizeCards(countOffers)}`;
      default:
        return 'Еще';
    }
  }, [offersType, countOffers]);

  return (
    <Space
      justify={isMobile ? 'center' : 'end'}
      size={4}
      align="center"
      onClick={onClick}
      className={styles.showMoreOffers}
    >
      <Typography.Text
        size={14}
        className="h-color-D60"
      >
        {isShowMore ? 'Свернуть' : offersCountText}
      </Typography.Text>

      <Icon
        size={16}
        icon={<ArrowDown className={cn(styles.arrow, { [styles.rotate]: isShowMore })} />}
      />
    </Space>
  );
};
